export const SeaStoryPart2 = {
    level: 12,
    name: 'Island adventures',
    cpu1Name: 'Thalassia Deep-Spear',
    cpu2Name: 'Oozelia',
    cpu3Name: 'Diana Ash',
    text: 'Time to hunt for treasures! 🏴‍☠️✨',
    classCss: 'map-island-adv-ico',
    cpu1: {
        id: 45,
        before: {
            type: 'comics',
            comicsSetting: {
                path: './img/stories/island_adv/1_intro/',
                slideNumber: 6
            }
        },
        after: {
            player: {
                type: 'comics',
                comicsSetting: {
                    path: './img/stories/island_adv/2_after_1st_battle/',
                    slideNumber: 6
                }
            },
            cpu: {
                type: 'text',
                step: {
                    0: 'A cannonball flies swifter than some wretched merfolk of the deep — perhaps you would do well to acquire a pair of cannons for yourself.',
                }
            }
        }
    },
    cpu2: {
        id: 46,
        before: {
            type: 'text',
            step: {
                0: "These clinging abominations are far more perilous than they appear.\n" +
                    "Be not deceived by their sweet and comely guise — first they multiply, and then they shall tear thee asunder.",
            }
        },

        after: {
            player: {
                type: 'comics',
                comicsSetting: {
                    path: './img/stories/island_adv/3_after_2nd_battle/',
                    slideNumber: 6
                }
            },
            cpu: {
                type: 'text',
                step: {
                    0: 'Hmm… This calls for something truly formidable.\n' +
                        'Perhaps the hour has come to turn to the Dark Magics? There is a spell whispered of in forbidden tomes — one that lays waste to all in a single, merciless instant.',
                }
            }
        }
    },
    cpu3: {
        id: 47,
        before: {
            type: 'text',
            step: {
                0: "I can feel the treasure close at hand — its gleam all but upon the wind.\n" +
                    "Yet a fearsome guardian bars our path. Come, let us fall upon it together and carve our way to fortune!",
            }
        },
        after: {
            cpu: {
                type: 'text',
                step: {
                    0: "What was that? Why did you hesitate?\n" +
                        "I held its fury at bay — you were meant to strike!",
                }
            },
            player: {

                type: 'comics',
                comicsSetting: {
                    path: './img/stories/island_adv/4_after_3rd_battle/',
                    slideNumber: 19,
                    animatedSlides: [8]
                }
            }
        },
    },
    cpu4: {
        id: 48,
        before: {
            type: 'text',
            step: {
                0: 'This island is famed for its savage and ill-tempered beasts.\n' +
                    'No matter — just mind the cannons well. They shall rend asunder whatever dares oppose us.',
            }
        },

        after: {
            player: {
                type: 'text',
                step: {
                    0: 'Another glorious triumph for Captain Sally Storm!\n' +
                        'As for you… our paths shall cross again, of that I have no doubt.”',
                }
            },
            cpu: {
                type: 'text',
                step: {
                    0: 'Blazes and barnacles! We were thrashed by crabs and cursed gulls! What part of the battle plan was unclear? You must protect the can-nons!',
                }
            }
        }
    },
}
